<style lang="less">
.ugo-tab-page{
    .m-segment{
        border:none;
        box-shadow: none;
    }
}
</style>
<template>
    <div style="width:100%;position:relative;min-height:100px;margin-bottom:10px;">
    <BaseTabs
        :items="tabs"
        :editable="design"
        :actived="activeTab"
        @on-change-tab="handleChangeTab"
        @on-click="handleSelect"
        @on-add="handleAddTab"
        @on-delete="handleRemoveTab"
    />

    <div class="ugo-tab-page"  :desc="config.desc" :icon="config.icon" style="width:100%;border:1px solid var(--border);">
          <draggable
            tag="div"
            v-model="activedPage.fields"
            group="control"
            :animation="500"
            @input="emitChange"
            :disabled="!design"
            filter=".drag-tip"
            style="background:#ffffffee;min-height:150px;width:100%;display: block;border:1px dashed #aaa;position:relative;"
            :style="`${design?'':'border:none;'}`"
          >
          <template v-if="design">
            <div class="flex-wrap flex-center" style="height:150px;width:100%;color:var(--primary)" v-if="!activePage.fields || activedPage.fields.length == 0">
              拖拽至此处
            </div>
            <template v-else>

              <template v-for="(c,i) in activedPage.fields">
                <div class="form-item flex-wrap flex-between" :class="selected && selected.id === c.id ?'form-item-selected':''"  :key="c.id"
                @click.stop="handleClick(c)" style="border:1px solid var(--primary);margin:12px;position:relative;overflow:hidden;padding:5px;">
                <div class="l-mask" v-if="!isContainer(c.control) && design"></div>
                <div class="l-remove-btn" @click.stop="localList.splice(i,1);emitChange()"><Icon type="md-close" /></div>
                  <component
                  :is="c.control"
                  :required="c.required?true:false"
                  :selected="selected"
                  :label="c.name"
                  :id="c.id"
                  :fields="c.fields"
                  :fkey="c.key"
                  :config="c.config"
                  :value="c?.config?.defaultValue"
                  :editable="editable"
                  :p_many="p_many"
                  :p_one="p_one"
                  :design="design"
                  @select="$emit('select', $event)"
                  @change="$set(c,'fields',$event);emitChange()"
                  />
                </div>

              </template>
                </template>
            </template>
            <template v-else>
              <template v-for="c in activedPage.fields">
                <div class="form-item flex-wrap flex-between"  :key="c.id"
                @click.stop="handleClick(c)"
                 v-if="acl[c.fullkey]!=2"
                style="position:relative;overflow:hidden;padding:5px;">
                  <component
                    :is="c.control"
                    :label="c.name"
                    :required="c.required?true:false"
                    :fkey="c.key"
                      :ref="c.key"
                    :fields="c.fields"
                    :acl="acl"
                    :id="c.id"
                     :model="model"

                    :config="c.config"
                    :editable="editable && (!c.config || !c.config.disabled) && !acl[c.fullkey]"
                       :old="isContainer(c.control)?old:(old?old[c.key]:undefined)"
                    :value="isContainer(c.control)?value:value[c.key]"
                     @input="handleEmitInput(c,$event)"
                  />

                </div>

              </template>
            </template>
            </draggable>

            <div v-show="false">
              <template v-for="p in otherPage">
                <template v-for="c in p.fields">
                <div class="form-item flex-wrap flex-between"  :key="c.id"
                @click.stop="handleClick(c)"
                 v-if="acl[c.fullkey]!=2"
                style="position:relative;overflow:hidden;padding:5px;">
                  <component
                    :is="c.control"
                    :label="c.name"
                    :required="c.required?true:false"
                    :fkey="c.key"
                    :fields="c.fields"
                    :acl="acl"
                      :ref="c.key"
                    :id="c.id"
                     :model="model"
                    :config="c.config"
                    :editable="editable && (!c.config || !c.config.disabled) && !acl[c.fullkey]"
                     :old="isContainer(c.control)?old:(old?old[c.key]:undefined)"
                    :value="isContainer(c.control)?value:value[c.key]"
                     @input="handleEmitInput(c,$event)"
                  />

                </div>

              </template>
              </template>
            </div>
    </div>
    </div>
  </template>

<script>
import BaseTabs from '@/components/app/tabs2';
import draggable from 'vuedraggable';

import composedMixin from '../mixins/composed';
import {cloneDeep} from 'lodash';
export default {
  cname: '标签页(容器)',
  icon: 'biaoge',
  corder: 80,
  components: {
    draggable, BaseTabs,
  },
  mixins: [composedMixin],
  data() {
    return {
      localList: cloneDeep(this.fields) || [],
      activeTab: null,
      otherPage: [],
      activedPage: {
        fields: [],
      },
    };
  },
  watch: {
    fields: {
      handler(v) {
        this.localList = Array.isArray(v) ? cloneDeep(v) : [];
        if (this.localList.length > 0) {
          if (!this.activeTab || this.localList.find((v)=>v.key == this.activeTab) == null) {
            this.activeTab = this.localList[0].key;
          }
          this.activedPage = this.localList.find((v)=>v.key == this.activeTab);
          this.otherPage = this.localList.filter((v)=>v.key != this.activeTab);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    tabs() {
      return this.localList.map((v)=>({key: v.key, name: v.name}));
    },
  },
  mounted() {
    const v = this.fields;
    this.localList = Array.isArray(v) ? cloneDeep(v) : [];
    if (this.localList.length > 0) {
      this.activeTab = this.localList[0].key;
      this.activedPage = this.localList[0];
      this.otherPage = this.localList.slice(1);
    }
  },
  props: {
    design: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Object,
    },
    fields: {
      type: Array,
      default: ()=>([]),
    },
    acl: {
      type: Object,
      default: ()=>({}),
    },
    label: {
      type: String,
    },
    model: {
      type: Object,
      default: ()=>({}),
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    editable: {
      type: Boolean,
    },
    config: {
      type: Object,
      default: ()=>({}),
    },
    acl: {
      type: Object,
      default: ()=>({}),
    },

  },
  properties: [
    {
      label: '描述',
      key: 'desc',
      control: 'Text',
    },

  ],
  methods: {
    handleChangeTab(e) {
      const {index, value} = e;
      this.$set(this.localList[index], 'name', value);
      this.emitChange();
    },
    getUpdateData() {
      const updateData = {};
      this.localList.forEach((p)=>{
        if (!p.fields) {
          return;
        }
        p.fields.forEach((f)=>{
          if (!Array.isArray(this.$refs[f.key]) || !this.$refs[f.key][0]) {
            return;
          }
          const component = this.$refs[f.key][0];
          const getUpdate = component.getUpdateData;
          if (getUpdate) {
            const val = getUpdate();
            if (this.isContainer(f.control)) {
              if (val && Object.keys(val).length > 0) {
                Object.assign(updateData, val);
              }
            } else {
              if (val !== undefined) {
                updateData[f.key] = val;
              }
            }
          } else {
            if ((this.old[f.key] !== this.value[f.key])) {
              updateData[f.key] = this.value[f.key];
            }
          }
        });
      });


      if (Object.keys(updateData).length > 0) {
        return updateData;
      }
    },
    handleEmitInput(c, e) {
      if (this.isContainer(c.control)) {
        this.$emit('input', e);
      } else {
        this.$emit('input', {key: c.key, value: e});
      }
    },
    handleEnd(e) {
      console.log('end:', e);
    },
    handleAddTab() {
      const newTab = this.initTab(Date.now());
      this.localList.push(newTab);
      this.emitChange();
    },
    handleSelect(e) {
      this.activeTab = e;

      this.activedPage = this.localList.find((v)=>v.key == this.activeTab);
      this.otherPage = this.localList.filter((v)=>v.key != this.activeTab);
      this.$emit('select', {item: this.activedPage, ctx: this});
    },
    handleRemoveTab(t) {
      const index =this.localList.find((v)=>v.key == t.key);
      if (index== -1) {
        return;
      }
      if (this.localList[index].fields && this.localList[index].fields.length == 0) {
        this.localList.splice(index, 1);
      } else {
        this.Confirm(`确定移除标签页<span style="color:var(--primary);margin:0 3px">${t.name}</span>及其内所有元素)?`, ()=>{
          if (index !== -1) {
            this.localList.splice(index, 1);
          }
        });
      }
    },
    initTab(i) {
      return {
        id: this.fkey + 'tab'+i,
        key: this.fkey + 'tab'+i,
        name: '新标签',
        control: 'UgoTab',
        fields: [],
      };
    },
    emitChange() {
      this.$emit('change', cloneDeep(this.localList));
    },
    isContainer(control) {
      return this.$store.getters['forms/containers'].includes(control);
    },
  },

  initModel(obj) {
    obj.config = {
      cols: 2,
    };
    obj.fields = [{
      key: obj.id + 'tab0',
      name: '标签一',
      fields: [],
    }];
    return obj;
  },
};
</script>

  <style lang="scss" scoped>

  </style>
